<script>
	import { formatPhone, formatAddress, getDateFormatter } from "../../../../../SharedSvelte/Common.svelte";
	import {
		Button,
		Card,
		CardBody,
		CardHeader,
		CardText,
	} from "@sveltestrap/sveltestrap";

	let {
		relationship = "",
		fullName = "",
		memberId = "",
		residentialAddress1 = "",
		residentialAddress2 = "",
		residentialCity = "",
		residentialState = "",
		residentialZip = "",
        mailingAddress1 = "",
		mailingAddress2 = "",
		mailingCity = "",
		mailingState = "",
		mailingZip = "",
		dateOfBirth = null,
		homePhone = "",
		cellPhone = "",
		email = "",
        isPhiRestricted = false,
        hasPendingChanges = false,
		oneditcallback,
	} = $props();
	
	let dobObject = $derived(dateOfBirth ? new Date(dateOfBirth) : null);
	let formattedResidentialAddress = residentialAddress1 ? formatAddress(
        residentialAddress1, 
        residentialAddress2, 
        residentialCity, 
        residentialState, 
        residentialZip, "") : "None";
    let formattedMailingAddress = mailingAddress1 ? formatAddress(
        mailingAddress1, 
        mailingAddress2, 
        mailingCity, 
        mailingState, 
        mailingZip, "") : "None"; 

	const dateFormatter = getDateFormatter();

	function startEditing(event) {
		event.preventDefault();
		if (oneditcallback) {
			oneditcallback({ memberId });
		}
	}
</script>


<Card>
	<CardHeader>
		{fullName} <small>({relationship})</small>
	</CardHeader>
    {#if isPhiRestricted}
        <CardBody>
		    <CardText>
			    <ul class="list-group list-group-flush"> 
				    <li class="list-group-item">
                        <div class="row">
                            <div class="col-md-4 col-sm-4 col-xs-4">Member ID:</div>
                            <div class="col-md-6 col-sm-6 col-xs-12 ms-2"><strong>{memberId}</strong></div>
                        </div>
                    </li>
                </ul>
                <p class="alert alert-warning">
                    <b>You do not have access to see this dependent's information.</b>
                </p>
		    </CardText>
        </CardBody>
    {:else}
	    <CardBody>
		    <CardText>
			    <ul class="list-group list-group-flush"> 
				    <li class="list-group-item">
                        <div class="row">
                            <div class="col-md-4 col-sm-4 col-xs-4">Member ID:</div>
                            <div class="col-md-6 col-sm-6 col-xs-12 ms-2"><strong>{memberId}</strong></div>
                        </div>
                    </li>
                    <li class="list-group-item">
                        <div class="row">
                            <div class="col-md-4 col-sm-4 col-xs-4">Email:</div>
                            <div class="col-md-6 col-sm-6 col-xs-12 ms-2"><strong>{email}</strong></div>
                        </div>
                    </li>
                    <li class="list-group-item mt-1">
                        <div class="row">
                            <div class="col-md-4 col-sm-4 col-xs-12">Cell Phone:</div>
                            <div class="col-md-6 col-sm-6 col-xs-12 ms-2"><strong>{formatPhone(cellPhone)}</strong></div>
                        </div>
                    </li>
                    <li class="list-group-item mt-1">
                        <div class="row">
                            <div class="col-md-4 col-sm-4 col-xs-12">Home Phone:</div>
                            <div class="col-md-6 col-sm-6 col-xs-12 ms-2"><strong>{formatPhone(homePhone)}</strong></div>
                        </div>
                    </li>                                                                                             
                    <li class="list-group-item mt-1">
                            <div class="row">
                                <div class="col-md-4 col-sm-4 col-xs-12">Residential Address:</div>
                                <div class="col-md-6 col-sm-6 col-xs-12 ms-2"><strong>{@html formattedResidentialAddress}</strong></div>
                        </div>                                                              
                    </li>
                    <li class="list-group-item mt-1">
                            <div class="row">
                                <div class="col-md-4 col-sm-4 col-xs-12">Mailing Address:</div>
                                <div class="col-md-6 col-sm-6 col-xs-12 ms-2"><strong>{@html formattedMailingAddress}</strong></div>
                        </div> 
                    </li>
                    <li class="list-group-item mt-1">
                        <div class="row">
                            <div class="col-md-4 col-sm-4 col-xs-12">Date of Birth</div>
                            <div class="col-md-6 col-sm-6 col-xs-12 ms-2"><strong>{dateFormatter.format(dobObject)}</strong></div>
                        </div> 
                    </li>
                </ul>

		    </CardText>
            {#if hasPendingChanges}
			    <div class="alert alert-warning">
				    There are pending changes for this dependent.	
			    </div>
		    {:else}
		        <Button color="primary" class="btn-lg" onclick={startEditing}>Edit</Button>
            {/if}
	    </CardBody>
    {/if}
</Card>

